import { render, staticRenderFns } from "./ModalBetDetail.vue?vue&type=template&id=c6e5e72a&scoped=true"
import script from "./ModalBetDetail.vue?vue&type=script&lang=js"
export * from "./ModalBetDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalBetDetail.vue?vue&type=style&index=0&id=c6e5e72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e5e72a",
  null
  
)

export default component.exports